import React, { useState, useEffect } from 'react';
import { BookOpen } from 'lucide-react';
import barnumLogo from '../assets/barnum-evenement-logo.jpeg';

// Modification #10: Vert à gauche, Orange à droite
// Modification #11: Logo Barnum Événement pour le catalogue orange
// Modification #33: Liens catalogues gérés depuis l'admin

const CatalogSection = () => {
  const [catalogLinks, setCatalogLinks] = useState({
    url_3dloc: 'https://heyzine.com/flip-book/ada9b209bb.html',
    url_barnum: 'https://heyzine.com/flip-book/d8789c509d.html'
  });

  const API_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    // Récupérer les liens des catalogues depuis le backend
    const fetchCatalogLinks = async () => {
      try {
        const response = await fetch(`${API_URL}/api/catalog-links`);
        if (response.ok) {
          const data = await response.json();
          setCatalogLinks(current => ({
            url_3dloc: data.url_3dloc || current.url_3dloc,
            url_barnum: data.url_barnum || current.url_barnum
          }));
        }
      } catch (err) {
        console.log('Utilisation des liens catalogue par défaut');
      }
    };
    fetchCatalogLinks();
  }, [API_URL]);

  const catalogs = [
    {
      id: 1,
      title: "Bricolage - Jardinage - Nettoyage",
      cardTitle: "3DLoc - Bricolage & Jardinage",
      description: "Engins Terrassement, Outillage, Motoculture, Entretien des jardins, Coupe du bois, Nettoyage, Indispensables pour le Logement",
      url: catalogLinks.url_3dloc,
      color: "from-green-500 to-green-600",
      bgColor: "bg-green-50",
      image: "https://images.unsplash.com/photo-1581166418878-11f0dde922c2?w=600&auto=format",
      logo: "/media/logo-cmjn-long-3dloc-high-95e288e8.jpg"
    },
    {
      id: 2,
      title: "Barnum Événement",
      cardTitle: "Barnum Événement",
      description: "Tentes de réception, Tables, Chaises, Sono, Ambiance, Lumières, Chauffage, Restauration, Structures gonflables",
      url: catalogLinks.url_barnum,
      color: "from-orange-500 to-orange-600",
      bgColor: "bg-orange-50",
      image: "/media/pexels-photo-2306281-d16412c3.jpg",
      logo: barnumLogo
    }
  ];
  return (
    <section className="py-20 bg-gradient-to-br from-slate-100 to-slate-200">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full shadow-sm mb-6">
            <BookOpen className="text-green-500" size={20} />
            <span className="text-sm font-semibold text-slate-700">Téléchargement gratuit</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-black text-slate-800 mb-4">
            Nos <span className="text-green-500">Catalogues</span>
          </h2>
          <p className="text-slate-600 text-lg max-w-2xl mx-auto">
            Consultez nos catalogues interactifs pour découvrir l'ensemble de notre matériel disponible à la location
          </p>
        </div>

        {/* Catalogs Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {catalogs.map((catalog) => (
            <div 
              key={catalog.id}
              className="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow duration-300"
            >
              {/* Catalog Preview */}
              <div className={`relative h-64 ${catalog.bgColor} flex items-center justify-center overflow-hidden`}>
                <div className="absolute inset-0 opacity-20">
                  <img 
                    src={catalog.image} 
                    alt={catalog.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="relative z-10 text-center">
                  <div className="bg-white rounded-2xl shadow-2xl p-6 transform hover:scale-105 transition-transform duration-300">
                    <img 
                      src={catalog.logo} 
                      alt={catalog.title} 
                      className={catalog.id === 2 ? "h-16 mx-auto mb-3 rounded-full" : "h-12 mx-auto mb-3"}
                    />
                    <div className={`text-2xl font-black bg-gradient-to-r ${catalog.color} bg-clip-text text-transparent`}>
                      CATALOGUE 2026
                    </div>
                    <div className="text-sm text-slate-500 mt-1">{catalog.cardTitle}</div>
                  </div>
                </div>
              </div>

              {/* Catalog Info */}
              <div className="p-6 flex flex-col" style={{ minHeight: '220px' }}>
                <h3 className="text-xl font-bold text-slate-800 mb-2">
                  {catalog.title}
                </h3>
                <p className="text-slate-600 mb-4 flex-grow">
                  {catalog.description}
                </p>

                {/* Buttons */}
                <div className="flex flex-col sm:flex-row gap-3">
                  <a
                    href={catalog.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`flex-1 flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r ${catalog.color} text-white font-semibold rounded-xl hover:shadow-lg transition-all`}
                  >
                    <BookOpen size={18} />
                    Feuilleter le catalogue
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-slate-500 mb-4">Besoin d'un devis personnalisé ?</p>
          <a
            href="/contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-slate-900 text-white font-bold rounded-xl hover:bg-slate-800 transition-colors"
          >
            Demander un devis gratuit
          </a>
        </div>
      </div>
    </section>
  );
};

export default CatalogSection;
